import { t } from '../../i18n/t';
import { formatDateTimeIL } from '../../utils/dateTime';

const nf = new Intl.NumberFormat('he-IL', { maximumFractionDigits: 1 });
const nfInt = new Intl.NumberFormat('he-IL', { maximumFractionDigits: 0 });
const nfFull = new Intl.NumberFormat('he-IL', {
  style: 'currency',
  currency: 'ILS',
  maximumFractionDigits: 2,
});
const nfPct = new Intl.NumberFormat('he-IL', {
  style: 'percent',
  maximumFractionDigits: 1,
});

/** Counts with thousands separators. */
export function formatCount(n: number): string {
  return nfInt.format(n);
}

/** Abbreviated shekels for heroes / axes: "105.6 מ׳ ₪", "1.2 מיליארד ₪". */
export function formatShekelsShort(n: number): string {
  const abs = Math.abs(n);
  if (abs >= 1e9) return `${nf.format(n / 1e9)} ${t('dashboard.unitBillion')} ₪`;
  if (abs >= 1e6) return `${nf.format(n / 1e6)} ${t('dashboard.unitMillion')} ₪`;
  if (abs >= 1e3) return `${nf.format(n / 1e3)} ${t('dashboard.unitThousand')} ₪`;
  return `${nfInt.format(n)} ₪`;
}

/** Full-precision shekels for tooltips. */
export function formatShekelsFull(n: number): string {
  return nfFull.format(n);
}

export function formatPercent(fraction: number): string {
  return nfPct.format(fraction);
}

/** 'yyyy-MM-dd[...]' -> 'dd/MM/yyyy' (string slicing: no timezone drift). */
export function formatDate(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  return m ? `${m[3]}/${m[2]}/${m[1]}` : iso;
}

/** 'yyyy-MM-dd' -> 'dd/MM' for the trend X axis. */
export function formatDayMonth(iso: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  return m ? `${m[3]}/${m[2]}` : iso;
}

export function formatDateTime(iso: string | null | undefined): string | null {
  if (!iso) return null;
  return formatDateTimeIL(iso) || iso;
}

export function formatClock(d: Date): string {
  return formatDateTimeIL(d).slice(-5);
}

/** Fixed entity -> color/label mapping (never by rank). Used by both charts. */
const FUND_TYPE_VIZ: Record<number, { color: string; labelKey: 'dashboard.fundTypeEtf' | 'dashboard.fundTypeTracker' | 'dashboard.fundTypeBuffer' | 'dashboard.fundTypeActive' }> = {
  3: { color: 'var(--viz-fund-etf)', labelKey: 'dashboard.fundTypeEtf' },
  2: { color: 'var(--viz-fund-tracker)', labelKey: 'dashboard.fundTypeTracker' },
  7: { color: 'var(--viz-fund-buffer)', labelKey: 'dashboard.fundTypeBuffer' },
  9: { color: 'var(--viz-fund-active)', labelKey: 'dashboard.fundTypeActive' },
};
export const FUND_TYPE_ORDER = [3, 2, 7, 9];

export function fundTypeViz(fundTypeId: number, apiName: string): { color: string; label: string } {
  const v = FUND_TYPE_VIZ[fundTypeId];
  return v
    ? { color: v.color, label: t(v.labelKey) }
    : { color: 'var(--color-text-disabled)', label: apiName };
}
